<template>
  <div
    class="main-sidebar"
    tabindex="1"
    style="overflow: hidden; outline: none;"
    :class="themeRender"
  >
    <aside id="sidebar-wrapper">
      <div class="sidebar-brand">
        <router-link to="/">
          <img
            alt="image"
            src="../assets/img/logo.png"
            width="50"
            height="80"
            class="rounded-circle"
          />
          <span>{{ $t("messages.general.sysName") }}</span>
        </router-link>
      </div>
      <div
        v-if="appInfo.data.USER_TYPE !== 'S' && appInfo.data.USER_TYPE !== 'A'"
        @click="backToOldReg()"
        style="width: 100%; padding: 0 15px; color: #fff; cursor: pointer; height: 50px; margin-top: 25px; display: inline-flex"
      >
        <div style="display: flex; align-items: center">
          <i class="fas fa-sign-out-alt" style="margin: 0 15px 0 4px"></i>
        </div>
        <div style="display: flex; align-items: center">
          <span
            ><u>{{ $t("messages.general.backToOld") }}</u></span
          >
        </div>
      </div>
      <div
        v-if="!isLoginAs"
        @click="backToER()"
        style="width: 100%; padding: 0 15px; color: #fff; cursor: pointer; height: 50px; display: inline-flex"
      >
        <div style="display: flex; align-items: center">
          <i class="fas fa-sign-out-alt" style="margin: 0 15px 0 4px"></i>
        </div>
        <div style="display: flex; align-items: center">
          <span
            ><u>{{ $t("messages.general.99") }}</u></span
          >
        </div>
      </div>
      <div
        v-else
        @click="logoffAs()"
        style="width: 100%; padding: 0 15px; color: #fff; cursor: pointer; height: 50px; display: inline-flex"
      >
        <div style="display: flex; align-items: center">
          <i class="fas fa-sign-out-alt" style="margin: 0 15px 0 4px"></i>
        </div>
        <div style="display: flex; align-items: center">
          <span
            ><u>{{ $t("messages.general.logoffAs") }}</u></span
          >
        </div>
      </div>
      <div class="sidebar-brand sidebar-brand-sm">
        <router-link to="/">
          <img
            alt="image"
            src="../assets/img/logo.png"
            width="50"
            height="80"
            class="rounded-circle"
          />
        </router-link>
      </div>
      <ul class="sidebar-menu">
        <li v-for="menu in menus" :key="menu.MENU_ID" role="tablist">
          <router-link
            active-class="active"
            v-if="menu.hasSubItems === ''"
            v-bind:class="menu.hasSubItems"
            @click="handleClick(menu, childMenu)"
          >
            <i class="fas fa-book-reader"></i>
            <span>{{ getMenuText(menu) }}</span>
          </router-link>
          <router-link
            v-if="menu.hasSubItems !== ''"
            to="#"
            data-toggle="collapse"
            v-bind:class="menu.hasSubItems"
            v-b-toggle="'collapse0' + menu.MENU_ID"
          >
            <i class="fas fa-book-reader"></i>
            <span>{{ getMenuText(menu) }}</span>
          </router-link>
          <b-collapse
            v-if="appInfo.data.USER_TYPE != 'S'"
            v-bind:id="'collapse0' + menu.MENU_ID"
            visible
          >
            <!-- accordion="side-bar"
            role="tab" -->
            <a
              v-for="childMenu in menu.Children"
              :key="childMenu.MENU_ID"
              :class="getMenuClass(childMenu)"
              @click="handleClick(menu, childMenu)"
            >
              <i class="fas fa-angle-double-right"></i>
              <span> {{ getMenuText(childMenu) }}</span>
            </a>
          </b-collapse>
          <b-collapse
            v-if="appInfo.data.USER_TYPE == 'S'"
            v-model="showCollapse"
            v-bind:id="'collapse0' + menu.MENU_ID"
            accordion="side-bar"
            role="tab"
            visible
          >
            <a
              v-for="childMenu in menu.Children"
              :key="childMenu.MENU_ID"
              :class="getMenuClass(childMenu)"
              @click="handleClick(menu, childMenu)"
            >
              <i class="fas fa-angle-double-right"></i>
              <span> {{ getMenuText(childMenu) }}</span>
            </a>
          </b-collapse>
        </li>
      </ul>
    </aside>
  </div>
</template>
<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
// import MasterDataProvider from "@/services/masterData_provider";

// const masterDataProvider = new MasterDataProvider();
export default {
  name: "Menu",
  data: function() {
    return {
      menus: [],
      themeRender: "",
      showCollapse: false,
    };
  },
  mounted() {
    this.checkTheme();
    this.loadMenu();
    this.showCollapse = true;
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      isAuth: "isAuth",
      token: "getToken",
      appMenus: "getMenu",
      theme: "getTheme",
      userId: "getUserId",
      studentInfo: "getStudentInfo",
      studentId: "getStudentId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentMenu: function() {
      return this.appInfo.currentMenu;
    },
    currentUserId: function() {
      return _.isEmpty(this.studentInfo.data) ? this.userId : this.studentId;
    },
    isLoginAs: function() {
      return !_.isEmpty(this.studentInfo.data);
    },
  },
  methods: {
    ...mapActions("application", [
      "setCurrentMenu",
      "switchTheme",
      "clearStudentInfo",
    ]),
    loadMenu: async function() {
      if (this.appMenus && this.appMenus.length > 0) {
        this.initMenu(this.appMenus);
      } else {
        await this.getMenu();
      }
    },
    backToER: function() {
      // let sessionguid = localStorage.getItem("sessionguid");
      // if (sessionguid !== null) {
      // }
      if (this.appInfo.data.USER_TYPE == "S") {
        this.$router.push("/redirectback");
      } else if (this.appInfo.data.USER_TYPE == "R") {
        this.$router.push("/redirectbackstaff");
      } else if (this.appInfo.data.USER_TYPE == "A") {
        this.$router.push("/redirectbackinstructor");
      } else {
        this.$router.push("/redirectold");
      }
    },
    backToOldReg: function() {
      this.$router.push("/redirectold");
    },
    getMenu: async function() {
      if (this.isAuth) {
        const data = await masterDataProvider.getMenu({
          token: this.token,
          userId: this.currentUserId,
          lang: this.currentLang,
        });
        this.initMenu(data);
      }
    },
    getMenuText: function(menu) {
      return this.currentLang == "th" ? menu.MENU_NAME : menu.MENU_NAMEENG;
    },
    getMenuClass: function(menu) {
      return menu.MENU_ID == this.currentMenu.id ? "active" : "";
    },
    initMenu: function(data) {
      let isLoginAs =  (!_.isEmpty(this.studentInfo.data));
      let isNotStudent = this.appInfo.data.USER_TYPE !== 'S';
      
      if(isLoginAs === false && isNotStudent === true) {
        data = data.filter(menu => menu.MENU_NAME !== 'สำหรับนักศึกษา');
      }

      let parentMenus = data
        .filter((d) => d.MENU_PARENT == 0)
        .map((d) => {
          const temp = {
            ...d,
          };
          if (d.MENU_NAVIGATIONURL_NEW && d.MENU_NAVIGATIONURL_NEW != null) {
            temp.MENU_NAVIGATIONURL_NEW = d.MENU_NAVIGATIONURL_NEW.replace(
              "\n",
              ""
            );
          }
          return temp;
        });
      parentMenus = _.orderBy(parentMenus, "MENU_ORDER_NEW", "asc");
      // parentMenus.push({
      //   MENU_ICON: "cube",
      //   MENU_ID: 999,
      //   MENU_NAME: "สำหรับเจ้าหน้าที่ทะเบียน",
      //   MENU_NAMEENG: "สำหรับเจ้าหน้าที่ทะเบียน(EN)",
      //   MENU_NAVIGATIONURL_NEW: null,
      //   MENU_ORDER_NEW: 11,
      //   MENU_PARENT: 0,
      //   USERGROUPID: 3
      // });
      parentMenus.map((p) => {
        let childMenus = data
          .filter((d) => d.MENU_PARENT == p.MENU_ID)
          .map((d) => {
            const temp = {
              ...d,
            };
            if (d.MENU_NAVIGATIONURL_NEW && d.MENU_NAVIGATIONURL_NEW != null) {
            console.log('d.MENU_NAVIGATIONURL_NEW', d.MENU_NAVIGATIONURL_NEW)
              temp.MENU_NAVIGATIONURL_NEW = d.MENU_NAVIGATIONURL_NEW.replace(
                "\n",
                ""
              );
            }
            return temp;
          });
        childMenus = _.orderBy(childMenus, "MENU_ORDER_NEW", "asc");
        //   if (p.MENU_NAME == "สำหรับผู้ประสานงานตารางสอนฯ") {
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 9,
        //       MENU_NAME: "บันทึกจำนวนรับลงทะเบียนเรียน",
        //       MENU_NAMEENG: "บันทึกจำนวนรับลงทะเบียนเรียน(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/updateRegisAmount",
        //       MENU_ORDER_NEW: 16,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 10,
        //       MENU_NAME: "ย้ายตอนเรียนในการแจ้งความประสงค์ ตามรายวิชา",
        //       MENU_NAMEENG: "ย้ายตอนเรียนในการแจ้งความประสงค์ ตามรายวิชา(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/transferClassByCourse",
        //       MENU_ORDER_NEW: 17,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 11,
        //       MENU_NAME: "ย้ายตอนเรียนในการแจ้งความประสงค์ ตามรายบุคคล ",
        //       MENU_NAMEENG: "ย้ายตอนเรียนในการแจ้งความประสงค์ ตามรายบุคคล (EN)",
        //       MENU_NAVIGATIONURL_NEW: "/transferClassByPerson",
        //       MENU_ORDER_NEW: 18,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 12,
        //       MENU_NAME: "บันทึกสถานะการเปิดรับนักศึกษา",
        //       MENU_NAMEENG: "บันทึกสถานะการเปิดรับนักศึกษา(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/stuAdmissionStatusRec",
        //       MENU_ORDER_NEW: 19,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 13,
        //       MENU_NAME: "กำหนดสิทธิ์จัดการรายวิชา",
        //       MENU_NAMEENG: "กำหนดสิทธิ์จัดการรายวิชา(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/permissionManageByCourses",
        //       MENU_ORDER_NEW: 20,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 14,
        //       MENU_NAME: "อนุมัติการแจ้งความประสงค์ ช่วงการลงทะเบียนเรียนล่าช้า",
        //       MENU_NAMEENG:
        //         "อนุมัติการแจ้งความประสงค์ ช่วงการลงทะเบียนเรียนล่าช้า(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/appReqLateRegis",
        //       MENU_ORDER_NEW: 21,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 15,
        //       MENU_NAME: "ตรวจสอบผลการอนุมัติแจ้งความประสงค์ขอลงทะเบียนเรียน",
        //       MENU_NAMEENG:
        //         "ตรวจสอบผลการอนุมัติแจ้งความประสงค์ขอลงทะเบียนเรียน(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/chkResultsApprovalReqEnroll",
        //       MENU_ORDER_NEW: 22,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //   }
        //   if (p.MENU_NAME == "สำหรับเจ้าหน้าที่ทะเบียน") {
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 16,
        //       MENU_NAME:
        //         "กำหนดผู้ประสานงานตารางสอนตารางสอบ ประจำ ปี/ภาค การศึกษา",
        //       MENU_NAMEENG:
        //         "กำหนดผู้ประสานงานตารางสอนตารางสอบ ประจำ ปี/ภาค การศึกษา(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/setCoorSchedForYearSem",
        //       MENU_ORDER_NEW: 23,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 17,
        //       MENU_NAME: "กำหนดผู้ประสานงานตารางสอนตารางสอบ ประจำ รายวิชา",
        //       MENU_NAMEENG: "กำหนดผู้ประสานงานตารางสอนตารางสอบ ประจำ รายวิชา(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/setCoorSchedForCourse",
        //       MENU_ORDER_NEW: 24,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 18,
        //       MENU_NAME: "กำหนดหน่วยกิตของนักศึกษา",
        //       MENU_NAMEENG: "กำหนดหน่วยกิตของนักศึกษา(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/setCreditStuProbation",
        //       MENU_ORDER_NEW: 25,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 19,
        //       MENU_NAME: "กำหนดเงื่อนไขควบคุมการลงทะเบียนเรียน",
        //       MENU_NAMEENG: "กำหนดเงื่อนไขควบคุมการลงทะเบียนเรียน(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/setConditionCtrlEnroll",
        //       MENU_ORDER_NEW: 26,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 20,
        //       MENU_NAME: "ตรวจสอบประวัติการยกเลิกเงื่อนไขควบคุมการลงทะเบียนเรียน",
        //       MENU_NAMEENG:
        //         "ตรวจสอบประวัติการยกเลิกเงื่อนไขควบคุมการลงทะเบียนเรียน(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/chkHConditionCancelCtrlEnroll",
        //       MENU_ORDER_NEW: 27,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 21,
        //       MENU_NAME: "แจ้งความประสงค์ขอลงทะเบียนเรียน เป็นชุด",
        //       MENU_NAMEENG: "แจ้งความประสงค์ขอลงทะเบียนเรียน เป็นชุด(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/reqEnrollForSet",
        //       MENU_ORDER_NEW: 28,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 22,
        //       MENU_NAME: "ยกเลิกการแจ้งความประสงค์ขอลงทะเบียนเรียน",
        //       MENU_NAMEENG: "ยกเลิกการแจ้งความประสงค์ขอลงทะเบียนเรียน(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/cancelReqEnrollment",
        //       MENU_ORDER_NEW: 29,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 23,
        //       MENU_NAME: "ลบข้อมูลการแจ้งความประสงค์ขอลงทะเบียนเรียน",
        //       MENU_NAMEENG: "ลบข้อมูลการแจ้งความประสงค์ขอลงทะเบียนเรียน(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/clearDataReqEnroll",
        //       MENU_ORDER_NEW: 30,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 24,
        //       MENU_NAME: "ลงทะเบียนเรียนให้กับนักศึกษา เป็นชุด",
        //       MENU_NAMEENG: "ลงทะเบียนเรียนให้กับนักศึกษา เป็นชุด(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/regisStuForSet",
        //       MENU_ORDER_NEW: 31,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 25,
        //       MENU_NAME: "ลงทะเบียนรายวิชาที่มีสัญลักษณ์ P",
        //       MENU_NAMEENG: "ลงทะเบียนรายวิชาที่มีสัญลักษณ์ P(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/regisCoursesP",
        //       MENU_ORDER_NEW: 32,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 26,
        //       MENU_NAME: "ลงทะเบียนรักษาสถานภาพ / ลาพัก",
        //       MENU_NAMEENG: "ลงทะเบียนรักษาสถานภาพ / ลาพัก(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/registrationStatusLeave",
        //       MENU_ORDER_NEW: 33,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 27,
        //       MENU_NAME: "ยกเลิกการลงทะเบียนเรียนตามรายบุคคล",
        //       MENU_NAMEENG: "ยกเลิกการลงทะเบียนเรียนตามรายบุคคล(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/cancelindividualEnroll",
        //       MENU_ORDER_NEW: 34,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 28,
        //       MENU_NAME: "ยกเลิกการลงทะเบียนเรียนตามรายวิชา",
        //       MENU_NAMEENG: "ยกเลิกการลงทะเบียนเรียนตามรายวิชา(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/cancelRegisByCourse",
        //       MENU_ORDER_NEW: 35,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //     childMenus.push({
        //       MENU_ICON: "angle-double-right",
        //       MENU_ID: 29,
        //       MENU_NAME: "ตรวจสอบ log ในการแจ้งความประสงค์และในการลงทะเบียนเรียน",
        //       MENU_NAMEENG:
        //         "ตรวจสอบ log ในการแจ้งความประสงค์และในการลงทะเบียนเรียน(EN)",
        //       MENU_NAVIGATIONURL_NEW: "/logStudent",
        //       MENU_ORDER_NEW: 36,
        //       MENU_PARENT: 0,
        //       USERGROUPID: 3
        //     });
        //   }
        p["Children"] = childMenus;
        p["hasSubItems"] = "dropdown-toggle";
      });
      let index = parentMenus.findIndex(
        menu => menu.MENU_NAME === "สำหรับนักศึกษา"
      );
      if (index > -1) {
        parentMenus[index].Children.push({
          ENROLLPERIOD: 2,
          MENU_ICON: "angle-double-right",
          MENU_ID: 99999,
          MENU_NAME: "ชำระเงิน",
          MENU_NAMEENG: "Payment",
          MENU_NAVIGATIONURL_NEW: "/payment",
          MENU_ORDER_NEW: 99999,
          MENU_PARENT: 26,
          USERGROUPID: 1
        });
      }
      this.menus = parentMenus;
      console.log("parentMenus", parentMenus);
    },
    handleClick: function(menu, childMenu) {
      this.setCurrentMenu({
        mainMenu: {
          th: menu.MENU_NAME,
          en: menu.MENU_NAMEENG,
        },
        menu: {
          id: childMenu.MENU_ID,
          th: childMenu.MENU_NAME,
          en: childMenu.MENU_NAMEENG,
        },
      });
      switch (childMenu.MENU_NAVIGATIONURL_NEW) {
        case "/reqRegister":
        case "/chkResultRequest":
          this.switchTheme(1);
          break;
        default:
          this.switchTheme(0);
          break;
      }
      if (
        this.$router.history.current.path != childMenu.MENU_NAVIGATIONURL_NEW
      ) {
        this.$router.push(childMenu.MENU_NAVIGATIONURL_NEW);
      }
    },
    checkTheme: function() {
      const t = this.theme;
      if (!this.isAuth) {
        this.themeRender = "hidden";
      } else {
        switch (t) {
          case 1:
            this.themeRender = "temp-theme";
            break;
          case 0:
          default:
            this.themeRender = "";
            break;
        }
      }
    },
    logoffAs: function() {
      this.clearStudentInfo();
      this.$router.push("/");
    },
  },
  watch: {
    currentLang() {},
    appMenus(val) {
      if (val) {
        this.loadMenu();
      }
    },
    theme() {
      this.checkTheme();
    },
    isAuth() {
      this.checkTheme();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hidden {
  display: none;
}
.temp-theme::before {
  background: linear-gradient(
    180deg,
    rgba(11, 187, 236, 0.9) 0%,
    rgba(164, 70, 143, 0.9) 100%
  ) !important;
}
#sidebar-wrapper {
  box-shadow: 0 3px 6px rgba(123, 123, 123, 0.05);
  position: fixed;
  top: 0;
  height: 100%;
  width: 300px;
  z-index: 880;
  left: 300;
}
.sidebar-nav {
  position: absolute;
  top: 0;
  width: 300px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
}

.sidebar-nav li {
  text-indent: 20px;
  line-height: 40px;
}

.sidebar-nav li a {
  display: block;
  text-decoration: none;
  color: white;
}

.sidebar-nav li a:hover {
  text-decoration: none;
  color: #fff;
  text-shadow: 0 0 0.65px #fff, 0 0 0.65 #fff;
}

.sidebar-nav li a:active,
.sidebar-nav li a:focus {
  text-decoration: none;
}

.sidebar-nav > li > a > span {
  margin-left: 15px;
}

.sidebar-nav > .sidebar-brand {
  height: auto;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  line-height: 20px;
  font-size: 14px;
  padding-top: 10px;
}

.sidebar-nav > .sidebar-brand > a > img {
  width: 40px;
  margin-left: -30px;
  padding-bottom: 10px;
}

.sidebar-nav > .sidebar-brand a {
  color: #fff;
}

.sidebar-nav > .sidebar-brand a:hover {
  color: #fff;
  background: none;
}
.sidebar-nav > .sidebar-brand > hr {
  width: 85%;
  color: rgba(102, 97, 91, 0.3);
}
.dropdown-toggle::after {
  display: block;
  position: absolute;
  right: 20px;
  transform: translateY(-50%);
  top: 50%;
}
a[data-toggle="collapse"] {
  position: relative;
}
.collapse > a {
  padding-left: 30px !important;
  padding-right: 20px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  line-height: 20px !important;
}
.active {
  background: rgba(0, 0, 0, 0.4);
}
body.sidebar-mini .main-sidebar {
  width: 0px !important;
}
.main-sidebar .sidebar-menu li a{
  height: auto !important;
  min-height: 30px !important;
}
body.sidebar-mini #sidebar-wrapper {
  display: none;
}
</style>
